import { Directive, forwardRef, Input } from '@angular/core';
import { ApxControlDirective } from '../form/control.directive';

/**
 * This directive is responsible for setting the styling for an input element.
 */
@Directive({
    selector: 'input[apxInput]',
    standalone: true,
    providers: [
        {
            provide: ApxControlDirective,
            useExisting: forwardRef(() => ApxInputDirective)
        }
    ]
})
export class ApxInputDirective extends ApxControlDirective {
    @Input() set size(size: 'small' | 'standard' | 'full') {
        this.removeClasses(['max-w-input_small', 'max-w-input_standard']);
        if (size !== 'full') {
            this.addClasses([`max-w-input_${size}`]);
        }
        this._size = size;
    }
    get size() {
        return this._size;
    }

    private _size!: 'small' | 'standard' | 'full';

    setBaseClasses() {
        this.addClasses([
            'px-xs',
            'font-roboto',
            'border-input-border-default',
            'border-solid',
            'border-input',
            'bg-input-background-default',
            'text-input-text',
            'text-input',
            'rounded-input',
            'h-input',
            'focus:outline-none',
            'focus:border-input-border-focus',
            'cursor-pointer',
            'active:border-input-border-active',
            'disabled:cursor-auto',
            'disabled:bg-input-background-disabled',
            'w-full',
            'box-border'
        ]);
        if (this.size && this.size !== 'full') {
            this.addClasses([this.size === 'small' ? 'max-w-input_small' : 'max-w-input_standard']);
        }
    }

    override setInvalidStyling(isInvalid: boolean) {
        if (isInvalid) {
            this.addClasses(['border-error', 'shadow-error']);
        } else {
            this.removeClasses(['border-error', 'shadow-error']);
        }
    }

    constructor() {
        super();
        this.setBaseClasses();
    }
}
